import { Box } from '@mui/material'
import { CookieBanner } from '~components/cookie-banner/cookie-banner'
import { GoToStageButton } from '~components/go-to-stage-button'
import { ReportIssue } from '~components/navigation-and-footer/footer/report-issue/report-issue'
import { COLORS } from '~theme/colors'
import { useNavAndFooterConstants } from '../../../hooks/use-nav-and-footer-constants'
import { FooterLinks } from './footer-links'
import useBreakpoint from '~hooks/use-breakpoint'

export function Footer({ withOutLeftNav }: { withOutLeftNav?: boolean }) {
  const { isMobileSize } = useBreakpoint(true)
  const { footerHeight, leftNavigationWidth } = useNavAndFooterConstants()

  return (
    <Box
      component="footer"
      sx={{
        position: 'absolute',
        width: '100%',
        bottom: -1,
        height: isMobileSize
          ? 'auto'
          : { xs: footerHeight.xs, lg: footerHeight.lg },
      }}
    >
      <ReportIssue />
      <Box
        sx={{
          background: COLORS.secondary.darkBlue,
          ml: withOutLeftNav ? 0 : leftNavigationWidth,
        }}
      >
        <Box sx={{ py: isMobileSize ? 2 : 4, pr: 2 }}>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              rowGap: isMobileSize ? 0 : 3,
              columnGap: isMobileSize ? 3 : 6,
              alignItems: 'center',
              justifyContent: 'end',
            }}
          >
            <GoToStageButton />
            <FooterLinks />
            <CookieBanner />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
